/* eslint-disable default-param-last */
export const userInfoReducer = (state = null, action) => {
  switch (action.type) {
    case 'SET_USER':
      return action.user;
    case 'ADD_MEMBERSHIPS':
      return {
        ...state,
        activeMembership: action.activeMembership,
      };
    default:
      return state;
  }
};
